import React from 'react'
import PropTypes from 'prop-types'

const handleFile = (delegate) => {
  const reader = new FileReader()

  return (e) => {
    const fileObject = e.target.files[0]
    let fileData = null

    reader.onload = (file) => {
      fileData = file.target.result
      if (delegate) delegate(fileData, fileObject)
    }

    // Return null if no file set
    if (delegate) delegate(fileData, fileObject)

    if (fileObject){
      reader.readAsDataURL(fileObject)
    }
  }
}

const FileInput = (props) => {
  const {
    input: {
      value: omitValue, onChange, onBlur, ...inputProps
    },
    meta: omitMeta,
    ...additionalProps
  } = props

  return (
    <input
      onChange={handleFile(onChange)}
      onBlur={handleFile(onBlur)}
      type="file"
      {...inputProps}
      {...additionalProps}
    />
  )
}

FileInput.propTypes = {
  dataTestId: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
}

export default FileInput
